import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { GetDraftInvoicesResponse } from '@/api/handlers/resources/purchases/responses';
import { PURCHASES_LIST_PAGE_SIZE } from '@/api/handlers/resources/purchases/queries';
import type { ApiResponse } from '@/api/handlers/responses';
import { PurchaseQueryKeys } from './purchaseQueryKeys';

/**
 * Drafts list behind the Active Drafts widget (`GET /purchases/
 * draft-invoices`). Keyed via `PurchaseQueryKeys` so the draft mutations can
 * write saved/discarded rows straight into this cache (optimistic update)
 * and invalidate it for reconciliation.
 */
export const useDraftInvoicesQuery = (
    pageSize = PURCHASES_LIST_PAGE_SIZE,
    enabled = true,
) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetDraftInvoicesResponse>>({
        queryKey: PurchaseQueryKeys.draftInvoiceList(pageSize),
        queryFn: () => apiClient.purchases.getDraftInvoices({ pageSize }),
        enabled,
        staleTime: 60_000,
    });
};
